export const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const HOURS = Array.from({ length: 24 }, (_, i) => i)

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function formatHour(hour: number): string {
  if (hour === 0) return '12 AM'
  if (hour < 12) return `${hour} AM`
  if (hour === 12) return '12 PM'
  return `${hour - 12} PM`
}

export function formatTime(isoString: string | null | undefined): string {
  if (!isoString) return ''
  const date = new Date(isoString)
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
}

export function toDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function getWeekStart(date: Date): Date {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  d.setDate(d.getDate() - d.getDay())
  return d
}

// Use the Thursday of a week to determine its "canonical" month
export function getWeekMonth(weekStartDate: Date): { year: number; month: number } {
  const thu = new Date(weekStartDate)
  thu.setDate(weekStartDate.getDate() + 4)
  return { year: thu.getFullYear(), month: thu.getMonth() + 1 }
}

export function formatWeekRange(weekStartDate: Date): string {
  const end = new Date(weekStartDate)
  end.setDate(weekStartDate.getDate() + 6)
  const sm = MONTH_NAMES[weekStartDate.getMonth()].slice(0, 3)
  const em = MONTH_NAMES[end.getMonth()].slice(0, 3)
  if (weekStartDate.getFullYear() !== end.getFullYear()) {
    return `${sm} ${weekStartDate.getDate()}, ${weekStartDate.getFullYear()} – ${em} ${end.getDate()}, ${end.getFullYear()}`
  }
  if (weekStartDate.getMonth() !== end.getMonth()) {
    return `${sm} ${weekStartDate.getDate()} – ${em} ${end.getDate()}, ${end.getFullYear()}`
  }
  return `${sm} ${weekStartDate.getDate()} – ${end.getDate()}, ${end.getFullYear()}`
}
